import React from 'react';
import { ContentsData } from '../helpers';

/**
 * 콘텐츠 데이터 상태와 세션 스토리지 영속화를 관리하는 훅.
 * @description
 * - 초기값은 세션 스토리지의 'contentsData'에서 복원한다(없으면 undefined = 로딩 상태).
 * - saveContentsData로 저장하면 세션 스토리지와 상태가 함께 갱신되어 새로고침 후에도 유지된다.
 */
export const useContentsData = () => {
  const [contentsData, setContentsData] = React.useState<
    ContentsData | undefined
  >(() => {
    try {
      const savedData = sessionStorage.getItem('contentsData');
      return savedData ? JSON.parse(savedData) : undefined;
    } catch (error) {
      console.error('콘텐츠 데이터 로드 실패:', error);
      return undefined;
    }
  });

  /**
   * 콘텐츠 데이터를 세션 스토리지에 저장하고 상태를 갱신한다.
   * @param data 저장할 콘텐츠 데이터
   */
  const saveContentsData = React.useCallback((data: ContentsData) => {
    try {
      sessionStorage.setItem('contentsData', JSON.stringify(data));
      setContentsData(data);
    } catch (error) {
      console.error('콘텐츠 데이터 저장 실패:', error);
    }
  }, []);

  return { contentsData, saveContentsData };
};
